/* LUNÉVA – yapışkan sepet çubuğu.
   Ana ürün formundaki "Sepete Ekle" butonu ekranda değilken çubuğu gösterir;
   çubuktaki buton ana butonu tıklatır (seçili varyant ve adet korunur). */
if (!customElements.get('luneva-sticky-cart')) {
  class LunevaStickyCart extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-sticky-button]');
      this.priceEl = this.querySelector('[data-sticky-price]');
      this.defaultLabel = this.dataset.label || this.button.textContent.trim();
      this.observed = null;
      this.visible = false;
      this.scheduled = false;

      this.observer = new IntersectionObserver((entries) => {
        const entry = entries[entries.length - 1];
        this.setVisible(!entry.isIntersecting);
      });

      this.button.addEventListener('click', () => {
        const main = this.mainButton();
        if (main && !main.disabled && main.getAttribute('aria-disabled') !== 'true') main.click();
      });

      const root = document.querySelector('product-info') || document.body;
      this.mutations = new MutationObserver(() => this.schedule());
      this.mutations.observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });

      this.refresh();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.mutations?.disconnect();
    }

    mainButton() {
      return document.querySelector('product-info .product-form__submit');
    }

    schedule() {
      if (this.scheduled) return;
      this.scheduled = true;
      requestAnimationFrame(() => {
        this.scheduled = false;
        this.refresh();
      });
    }

    refresh() {
      const main = this.mainButton();
      if (main && main !== this.observed) {
        if (this.observed) this.observer.unobserve(this.observed);
        this.observer.observe(main);
        this.observed = main;
      }

      if (main) {
        const unavailable = main.disabled || main.getAttribute('aria-disabled') === 'true';
        const text = (main.querySelector('span')?.textContent || '').trim();
        this.button.disabled = unavailable;
        this.button.textContent = unavailable && text ? text : this.defaultLabel;
      }

      const priceRoot = document.querySelector('product-info .price');
      if (priceRoot && this.priceEl) {
        const node = priceRoot.classList.contains('price--on-sale')
          ? priceRoot.querySelector('.price-item--sale')
          : priceRoot.querySelector('.price-item--regular');
        const value = (node?.textContent || '').trim();
        if (value) this.priceEl.textContent = value;
      }
    }

    setVisible(show) {
      if (show === this.visible) return;
      this.visible = show;
      this.classList.toggle('is-visible', show);
      this.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (show) this.removeAttribute('inert');
      else this.setAttribute('inert', '');
      document.body.classList.toggle('lv-sticky-on', show);
    }
  }

  customElements.define('luneva-sticky-cart', LunevaStickyCart);
}
